// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_freezer {
  border-radius: 50px;
  padding: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/freezerCamComponent/freezerCam.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".image_freezer {\n  border-radius: 50px;\n  padding: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
